export const locale = {
    lang: 'es',
    data: {
      'EDITOR': {
        'CARGANDO': 'Cargando información',
        'GUARDANDO': 'Guardando cambios',
        'ELEMENTOS': {
          'GUIA': 'Elementos de este bloque',
          'COLORES': {
            'ORIGINAL': 'Elemento sin modificar',
            'MODIFICADO': 'Elemento modificado'
          },
          'TOOLTIPS': {
            'ORIGINAL': 'Ningún elemento ha sido modificado',
            'MODIFICADO': 'Uno o más elementos han sido modificados',
            'COMPLETO': 'Todos los elementos han sido modificados',
            'AMPLIAR': 'Ver en tamaño grande',
            'ELIMINAR': 'Eliminar esta imagen',
            'IMPORTAR': 'Importar este elemento de otro idioma',
            'CONFIGDOMINIO': 'Configuración de dominio de backend',
            'COPIARURL': 'Copiar enlace'
          },
          'ETIQUETAS': {
            'INTERFAZ': {
              'TITULO': 'Configuración por broker',
              'SUBTITULO': 'Puede ver y modificar la configuración de cada broker disponible',
              'PASOINICIAL': 'Seleccione un broker de la lista para mostrar su configuración',
              'SELBROKER': 'Broker seleccionado',
              'SELOPC': 'Opción seleccionada',
              'SINJSONS': 'No se pudo cargar la información de este broker, intente más tarde',
              'DOMINIO': {
                'TITULO': 'Configuración de dominio de backend del broker',
                'ACTIVAR': 'Activar dominio asociado al broker',
                'DOMINIO': 'Dominio asociado al broker'
              },
              'MODAL': {
                'TITULO': 'Importar elemento',
                'SUBTITULO': 'Seleccione el idioma del que desee importar este elemento'
              }
            },
            'IMAGEN': {
              'NOHAY': 'No hay una imagen',
              'ACTUAL': 'Imagen actual'
            },
            'TEXTO': {
              'INGRESAR': 'Ingrese el texto'
            },
            'VIDEO': {
              'NOVIDEO': 'No ha cargado un video',
              'GUARDANDO': 'Guardando video, no salga de esta pantalla hasta que la carga se haya completado'
            }
          },
          'BOTONES': {
            'ENTRAR': 'Editar características de la encuesta',
            'REGRESAR': 'Regresar',
            'CONTINUAR': 'Continuar',
            'CANCELAR': 'Cancelar',
            'GUARDAR': 'Guardar cambios',
            'IMAGEN': 'Cambiar imagen',
            'EDITOR': 'Editar mensaje',
            'ELEMENTOS': 'Ayuda',
            'ACTIVAR': 'Mostrar',
            'DESACTIVAR': 'Ocultar',
            'VERVIDEO': 'Ver video',
            'CARGARVIDEO': 'Cargar archivo de video',
            'OTROVIDEO': 'Cargar otro archivo de video',
            'SI': 'Si',
            'NO': 'No',
            'INFO': 'Importante',
            'ADDIMG': 'Agregar imagen'
          },
          'MODALIMAGEN': {
            'TITULO': 'Agregar imagen al mensaje',
            'TABS': {
              'INSTRUCCIONES': {
                'TITULO': 'Instrucciones',
                'PASO_1': 'Haga clic en la pestaña \'Imágenes\', allí puede elegir una imagen ya cargada, o también puede cargar una imagen nueva',
                'PASO_2': 'Si desea elegir una imagen ya cargada, al colocar el cursor sobre la imagen deseada podrá realizar dos acciones: Ver la imagen o copiar el enlace',
                'PASO_2_1': 'Para obtener una vista previa, haga clic en el botón al botón sobre la imagen con el siguiente icono',
                'PASO_2_2': 'Para copiar el enlace, haga clic en el botón al botón sobre la imagen con el siguiente icono',
                'PASO_3': 'Si desea cargar una imagen nueva, haga clic en el botón con el siguiente icono',
                'PASO_4': 'Al terminar de cargar la imagen, obtendrá automáticamente el enlace de la misma',
                'PASO_5': 'Regrese al editor del mensaje y haga clic al botón para insertar una imagen, con el siguiente icono',
                'PASO_6': 'En la ventana emergente coloque el enlace copiado y establezca el tamaño de la imagen, expresado en pixeles. Al finalizar, haga clic en el botón Guardar. La ventana emergente se cerrará y la imagen será colocada en el editor con el tamaño establecido'
              },
              'IMAGENES': {
                'TITULO': 'Imágenes',
                'CARGANDO': 'Cargando imágenes disponibles',
                'NOTA': '* Las imágenes mostradas aquí se encuentran guardadas en el gestor de archivos',
                'TITULO_2': 'Imágenes disponibles',
                'ADD': 'Agregar una imagen nueva',
                'NOIMG': 'No hay imágenes disponibles',
                'URLCOPIADA': 'Se copio el enlace de la imagen al portapapeles',
                'OKBOT': 'Ok'
              },
            }
          }
        },
        'CATALOGOS': {
          'temas': {
            'temaFocusArea2': 'Set de colores 1',
            'theme-temaIzzi': 'Set de colores 2',
            'theme-blue-gray-dark': 'Set de colores 3',
            'theme-pink-dark': 'Set de colores 4',
            'theme-temaIzzi-2': 'Set de colores 5',
            'theme-temaItbm': 'Set de colores 6',
          },
          'numColumnas': {
            '1': '1 columna',
            '4': '4 columnas',
            '5': '5 columnas',
          },
          'segundos': {
            '1000': '1 segundo',
            '2000': '2 segundos',
            '3000': '3 segundos',
            '4000': '4 segundos',
            '5000': '5 segundos',
            '6000': '6 segundos',
            '7000': '7 segundos',
            '8000': '8 segundos',
            '9000': '9 segundos',
            '10000': '10 segundos',
            '11000': '11 segundos',
            '12000': '12 segundos',
            '13000': '13 segundos',
            '14000': '14 segundos',
            '15000': '15 segundos',
            '16000': '16 segundos',
            '17000': '17 segundos',
            '18000': '18 segundos',
            '19000': '19 segundos',
            '20000': '20 segundos',
          },
          'logosIniciales': {
            '0': 'Logotipo de CulturalGO'
          }
        },
        'ADVERTENCIAS': {
          'URLEXTERNA': 'Advertencia: Si el sitio de origen no permite el acceso a la página desde sitios externos el contenido no podrá visualizarse',
          'TEMPLATEFALTANTE': 'Advertencia: Esta plantilla no está disponible para este idioma',
          'CONFIGURACION': {
            'ACTIVAR': 'Precaución: Al activar la configuración personalizada, se colocarán en la interfaz de la plataforma todos los elementos especificados en esta pantalla, asegúrese de haber colocado todos los elementos correctos\n\n ¿Desea continuar y activar la configuración personalizada?',
            'DESACTIVAR': 'Precaución: Al desactivar la configuración personalizada, se colocarán los elementos por default establecidos en la plataforma para este broker y para todos los usuarios pertenecientes al mismo\n\n ¿Desea continuar y desactivar la configuración personalizada?'
          },
          'PRIORIDAD': {
            '1': 'Si este elemento se encuentra activo, se dará prioridad sobre las imagenes de fondo',
            '2': 'Si este elemento se encuentra activo, se dará prioridad sobre las imagenes de fondo y el fondo de video'
          }
        },
        'PANTALLAS': {
          'LOGIN': {
            'TITULO': 'Inicio de sesión',
            'PASOS': {
              'VARIOS': {
                'TITULO': 'Elementos varios',
                'ELEMENTOS': {
                  'images_broker': 'Logotipo del broker',
                  'title': 'Título principal',
                  'images_login': 'Logotipo del sistema',
                  'images_logout': 'Imagen mostrada al cerrar sesión',
                  'changeTime': 'Intervalo de tiempo entre imágenes'
                }
              },
              'BACKGROUNDS': {
                'TITULO': 'Imagenes de fondo',
                'ELEMENTOS': {
                  'agregar': 'Añadir una imagen',
                  'importar': 'Importar imágenes de otra configuración',
                }
              },
              'VIDEO': {
                'TITULO': 'Video de fondo',
                'ELEMENTOS': {
                  'enable': 'Habilitar video de fondo',
                  'video': 'Video a mostrar',
                  'loop': 'Activar repetición automática',
                  'mute': 'Mostrar video silenciado'
                }
              },
              'EXTERNO': {
                'TITULO': 'Contenido externo',
                'ELEMENTOS': {
                  'enable': 'Habilitar contenido externo',
                  'url': 'Enlace del contenido externo a mostrar',
                }
              }
            }
          },
          'HOME': {
            'TITULO': 'Pantalla inicial',
            'PASOS': {
              'BRAND':{
                'TITULO': 'Identidad del sistema en el menú lateral',
                'ELEMENTOS': {
                  'logo': 'Logotipo del sistema',
                  'name': 'Nombre del sistema'
                }
              },
              'LOGOINICIAL': {
                'TITULO': 'Logotipo inicial',
                'ELEMENTOS': {
                  'show': 'Mostrar logotipo inicial del sistema',
                  'time': 'Tiempo de visualización del logotipo (expresado en segundos)',
                  'type': 'Tipo de logotipo inicial a mostrar'
                }
              },
              'MOSAICO': {
                'TITULO': 'Mosaico de imágenes',
                'ELEMENTOS': {
                  'branding_show': 'Mostrar logotipo de marca del sistema',
                  'branding_image': 'Logotipo de marca del sistema',
                  'grayFilter': 'Filtro gris en imágenes de inicio',
                  'bgGridColumns': 'Numero de columnas de imágenes a mostrar'
                }
              },
              'TEMAS': {
                'TITULO': 'Tema de colores de la plataforma',
                'ELEMENTOS': {
                  'theme': 'Tema de colores a mostrar en el sistema'
                }
              },
              'BACKGROUNDS': {
                'TITULO': 'Imagenes de fondo',
                'ELEMENTOS': {
                  'agregar': 'Añadir una imagen',
                  'importar': 'Importar imágenes de otra configuración',
                }
              },
              'VIDEO': {
                'TITULO': 'Video de fondo',
                'ELEMENTOS': {
                  'enable': 'Habilitar video de fondo',
                  'video': 'Video a mostrar',
                  'loop': 'Activar repetición automática',
                  'mute': 'Mostrar video silenciado'
                }
              },
              'EXTERNO': {
                'TIUTLO': 'Contenido externo',
                'ELEMENTOS': {
                  'enable': 'Habilitar contenido externo',
                  'url': 'Enlace del contenido externo a mostrar',
                }
              },
              'LOADER': {
                'TITULO': 'Imagen .gif cargando',
                'ELEMENTOS': {
                  'image': 'Imagen cargando .gif',
                  'GUARDANDO': 'Guardando imagen, no salga de esta pantalla hasta que la carga se haya completado'
                }
              },
            }
          },
          'TEMPLATES': {
            'TITULO': 'Plantillas de correo',
            'PASOS': {
              'RT_1': {
                'TITULO': 'Requerimientos técnicos, enviado al registrar un nuevo producto',
                'ELEMENTOS': {
                  'asunto': 'Asunto del mensaje',
                  'mensaje': 'Cuerpo del mensaje'
                }
              },
              'RT_2': {
                'TITULO': 'Requerimientos técnicos, mensaje demo enviado durante su validación',
                'ELEMENTOS': {
                  'asunto': 'Asunto del mensaje',
                  'mensaje': 'Cuerpo del mensaje'
                }
              },
              'PASS_3': {
                'TITULO': 'Correo enviado al actualizar la contraseña de usuario',
                'ELEMENTOS': {
                  'asunto': 'Asunto del mensaje',
                  'mensaje': 'Cuerpo del mensaje'
                }
              },
              'PASS_4': {
                'TITULO': 'Correo enviado al actualizar el perfil de usuario',
                'ELEMENTOS': {
                  'asunto': 'Asunto del mensaje',
                  'mensaje': 'Cuerpo del mensaje'
                }
              },
              'GETMYCODE_6': {
                'TITULO': 'Correo enviado con GetMyCode',
                'ELEMENTOS': {
                  'asunto': 'Asunto del mensaje',
                  'mensaje': 'Cuerpo del mensaje'
                }
              },
              'RT_7': {
                'TITULO': 'Correo para aceptación de requerimientos técnicos',
                'ELEMENTOS': {
                  'asunto': 'Asunto del mensaje',
                  'mensaje': 'Cuerpo del mensaje'
                }
              },
            }
          }
        }
      }
    }
};
